import * as yup from 'yup';
import translation from 'i18n/translation.json';
import { getFixedLengthError, getLengthError } from 'utils';

export const useBankCardSchema = () => {
  const schema = yup.object().shape({
    cardNumber: yup
      .string()
      .trim()
      .required(translation.errors.requiredField)
      .transform(value => value?.replace(/\s+/g, ''))
      .max(16, translation.errors.bankCardLength),
    expireAt: yup
      .string()
      .required(translation.errors.requiredField)
      .length(5, getFixedLengthError(translation.errors.lengthFixed, 4))
      .test('invalid', 'Fecha de vencimiento inválida', value => {
        const [month] = value.split('/');
        return !(parseInt(month) > 12 || parseInt(month) <= 0);
      })
      .test('expired', 'Expiración vencida', value => {
        if (!value.includes('/')) return false;

        const currentDate = new Date();

        const [month, year] = value.split('/');
        const currentYear = parseInt(currentDate.getUTCFullYear().toString().substring(2));

        if (parseInt(year) < currentYear) {
          return false;
        } else if (parseInt(year) === currentYear && parseInt(month) < currentDate.getUTCMonth() + 1) {
          return false;
        }

        return true;
      }),
    cardholder: yup
      .string()
      .trim()
      .required(translation.errors.requiredField)
      .transform(value => value?.replace(/\s+/g, ' '))
      .min(5, getLengthError(translation.errors.length, 5, 60))
      .max(60, getLengthError(translation.errors.length, 5, 60))
      .matches(/^[a-zA-ZÁáÉéÍíÓóÚúÜüÑñ]+(( |-|\. ?)[a-zA-ZÁáÉéÍíÓóÚúÜüÑñ]+)*$/gimu, ({ value }) =>
        value ? translation.errors.invalidValue : true,
      ),
    cvc: yup
      .string()
      .required(translation.errors.requiredField)
      .min(3, getLengthError(translation.errors.length, 3, 4))
      .max(4, getLengthError(translation.errors.length, 3, 4))
      .matches(/^[0-9]*$/, ({ value }) => (value ? translation.errors.invalidValue : true)),
    save_card: yup.boolean(),
    direct_debit: yup.boolean(),
    make_default: yup.boolean(),
  });

  return { schema };
};
